<template>
  <div class="recharge_wrap">
    <div class="red_top_bg">
      <div
        class="back_left"
        @click="$router.back()"
      />
      <div class="big_tit">
        {{ $t('account.manage') }}
      </div>
    </div>
    <div class="wrap_box warp1">
      <p><span>{{ allNum }}</span> {{ $t('account.withdrawalAccounts') }}</p>
    </div>
    <div class="wrap_box warp2">
      <div
        v-for="i in data.bank"
        class="item"
      >
        <img
          :src="require('../images/user/recharge'+i.type+'.png')"
          alt=""
        >
        <div class="item_detail">
          <p class="user_name ari_font">
            {{ i.bank }}
          </p>
          <p class="user_num">
            {{ i.account }}
          </p>
        </div>
        <div
          class="del"
          @click="delCard(i.id)"
        />
      </div>
    </div>
    <div
      class="basic_btn"
      @click="$router.push('/addcountUsdt')"
    >
      {{ $t('account.add') }}
    </div>
  </div>
</template>

<script>
    import Fetch from '../../utils/fetch'

    export default {
        name: "Account",
        data() {
            return {
                allNum:0,
                data: {}
            };
        },
        created() {
            this.$parent.footer('user', false);
        },
        mounted() {
            this.start();
        },
        methods: {
            delCard(id){
                Fetch('/user/bank_remove', {id: id}).then(() => {
                    this.start()
                });
            },
            start(){
                Fetch('/user/my_bank').then(r=>{
                    this.data = r.data;
                    this.allNum = r.data.count;
                })
            }
        }
    };
</script>

<style lang="less" scoped>
    .red_top_bg {
        position: relative;
    }
	

    .warp1 {
        padding: 0 20px;
        height: 40px;

        p {
            font-size: 14px;
            line-height: 40px;
            color: rgba(0,0,0,.8);
            font-weight: bold;

            span {
                color: #F03041;
            }
        }
    }

    .ari_font {
        height: 20px;
        font-size: 14px;
        font-weight: 600;
        color: rgba(0,0,0,.8);
        line-height: 20px;
    }

    .warp2 {
        padding: 0 15px;
        margin-top: 12px;

        .item {
            padding: 14px 0 11px 0;
            display: flex;
            align-items: center;
            justify-content: flex-start;
            border-bottom: 1px solid #ECECEC;

            &:last-child {
                border-bottom: none;
            }

            img {
                width: 30px;
                height: 30px;
            }

            .item_name {
                width: 65px;
            }
			.item_detail{
				margin-left: 10px;
			}

            .user_num {
                height: 17px;
                font-size: 12px;
                font-weight: 600;
                color: rgba(0,0,0,.6);
                line-height: 17px;
                margin-top: 10px;
            }

            .del {
                width: 20px;
                height: 20px;
                background: url(../images/item/del.png) no-repeat center center;
                background-size: 100% 100%;
                margin: 0 8px 0 auto;
            }
        }
    }

    .basic_btn {
        margin: 50px auto 0 auto;
    }

    /* Ivory, champagne-gold and rose-wine account-management theme. */
    .recharge_wrap { min-height: 100vh; padding-bottom: calc(86px + env(safe-area-inset-bottom)); background: linear-gradient(160deg, #fffdf7, #fff5e3 60%, #f7e6c5); color: #553126; }
    .red_top_bg { height: 54px; background: rgba(255, 252, 245, .97); border-bottom: 1px solid rgba(190, 139, 52, .45); }
    .red_top_bg .big_tit, .red_top_bg .back_left { color: #8f251d; }
    .warp1 { margin: 14px; padding: 0 15px; border: 1px solid rgba(190, 139, 52, .52); border-radius: 13px; background: rgba(255, 254, 249, .94); box-shadow: 0 8px 16px rgba(126, 84, 29, .08); }
    .warp1 p { color: #6a3d2b; }.warp1 p span { color: #a6233d; }
    .warp2 { margin: 0 14px; padding: 0 14px; border: 1px solid rgba(190, 139, 52, .52); border-radius: 14px; background: rgba(255, 254, 249, .94); box-shadow: 0 8px 16px rgba(126, 84, 29, .08); }
    .warp2 .item { border-bottom-color: rgba(190, 139, 52, .24); }.warp2 .item img { border-radius: 8px; }.ari_font { color: #533126; }.warp2 .item .user_num { color: #815c45; }.warp2 .item .del { filter: sepia(.55) saturate(1.45) hue-rotate(305deg); }
    .basic_btn { width: calc(100% - 28px); height: 48px; margin: 25px 14px 0; border: 1px solid #b9802e; border-radius: 12px; background: linear-gradient(105deg, #a6233d, #ca5a5b); color: #fff9ea; line-height: 46px; box-shadow: 0 9px 20px rgba(151, 17, 56, .18); }
</style>
